/**
 * @author Ahto Jalak
 * @since 16.04.2023
 */
export default class DistanceUtil {
    calculateDistance (lat1: number, lon1: number, lat2: number, lon2: number, unit: string) {
        const radlat1 = Math.PI * lat1 / 180
        const radlat2 = Math.PI * lat2 / 180
        // const radlon1 = Math.PI * lon1 / 180
        // const radlon2 = Math.PI * lon2 / 180
        const theta = lon1 - lon2
        const radtheta = Math.PI * theta / 180
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
        dist = Math.acos(dist)
        dist = dist * 180 / Math.PI
        dist = dist * 60 * 1.1515
        if (unit === 'K') {
            dist = dist * 1.609344
        }
        if (unit === 'N') {
            dist = dist * 0.8684
        }
        return dist
    }

    round(distance: number) {
        return Math.round(distance * 100) / 100
    }
}
